import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

export const getAllSubsites = createAsyncThunk('subsite/getAllSubsites', async (data, thunkApi) => {
    try {
        console.log("SUBSITE REQUEST");
        var queryString = "";
        if(data.range) queryString += "?range=" + JSON.stringify(data.range);
        if(data.filter) queryString += (queryString ? "&" : "?") + "filter=" + encodeURIComponent(data.filter);
        if(data.active) queryString += (queryString ? "&" : "?") + "active=" + encodeURIComponent(data.active);
        
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/subsites" + queryString, { headers: AuthHeader.authHeaderFromState(thunkApi.getState())});
        console.log("SUBSITE RESPONSE" , response);
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const setSubsiteActive = createAsyncThunk('subsite/setSubsiteActive', async ({ id, active }, thunkApi) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + "/admin/subsites/" + id + "/active",
      { active },
      { headers: AuthHeader.authHeaderFromState(thunkApi.getState()) }
    );
    return response.data.data;
  });
  
  export const createSubsite = createAsyncThunk('subsite/', async (newSubsite, {rejectWithValue}) => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + "/subsite/create", 
          newSubsite,
          { headers: AuthHeader.authHeader() }
        );
        console.log("RESPONSE", response);
        return response.data;
    } catch (error) {
      console.log("ERROR RESPONSE", error);
      return rejectWithValue(error.response.data);
    }    
  });

  export const allSubsites = state => state.subsite.subsites;
  export const subsiteTotalCount = state => state.subsite.subsiteTotalCount;
  export const createStatus = state => state.subsite.createStatus;
  export const errorMessage = state => state.users.error;

  const initialState = {
    subsites: [],
    status: 'idle',
    error: null,
    subsiteTotalCount: 0,
    createStatus: 'idle',
    newSubsite: null
  };

  const subsiteSlice = createSlice({
    name: 'subsite',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
          .addCase(getAllSubsites.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getAllSubsites.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.subsites = action.payload.data;
            state.subsiteTotalCount = action.payload.count;
          })
          .addCase(getAllSubsites.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(setSubsiteActive.fulfilled, (state, action) => {
            const updated = action.payload;
            if (!updated || !updated.id) return;
            for (var i = 0; i < state.subsites.length; i++) {
              if (state.subsites[i].id === updated.id) {
                state.subsites[i] = { ...state.subsites[i], active: updated.active };
                break;
              }
            }
          })
          .addCase(createSubsite.pending, (state, action) => {
            console.log("PENDING", action);
            state.createStatus = 'loading';
            state.error = "";
          })
          .addCase(createSubsite.fulfilled, (state, action) => {
            console.log("SUCCESS", action);
            state.createStatus = 'succeeded';
            state.newSubsite = action.payload;
            state.subsites.push(action.payload);
            state.error = "";
          })
          .addCase(createSubsite.rejected, (state, action) => {
            console.log("ACTION", action);
            state.createStatus = 'failed';
            state.error = action.payload.message;
          })
      }
  });
  
  export default subsiteSlice.reducer;




